import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import {
  TransactionFilterState,
  TransactionMethodType,
  TransactionReportContent,
  TransactionStatusType,
  TransactionsType,
} from '@/types/transactions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TransactionsState = {
  data: TransactionsType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  dataDetailsTransaction?: TransactionsType;
  filters: TransactionFilterState;
  dataStatusTransaction?: TransactionStatusType[];
  dataMethodTransaction?: TransactionMethodType[];
  transactionReport?: TransactionReportContent
};

export const transactionsInitialState: TransactionsState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  dataDetailsTransaction: undefined,
  filters: {},
  dataStatusTransaction: [],
  dataMethodTransaction: [],
  transactionReport: undefined
};

const slice = createSlice({
  name: 'transactions',
  initialState: transactionsInitialState,
  reducers: {
    setListTransactionsAction(
      state,
      action: PayloadAction<{
        data: TransactionsType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      const { payload } = action;
      state.data = payload.data;

      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setDetailsTransactionAction(state, { payload }: PayloadAction<TransactionsType>) {
      state.dataDetailsTransaction = payload;
    },

    setTransactionFiltersAction(state, action: PayloadAction<TransactionFilterState>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetTransactionFiltersAction(state) {
      state.filters = {};
    },
    setTransactionStatusAction(
      state,
      action: PayloadAction<{
        dataStatusTransaction: TransactionStatusType[];
      }>,
    ) {
      const { payload } = action;
      state.dataStatusTransaction = payload.dataStatusTransaction;
    },
    setTransactionMethodAction(
      state,
      action: PayloadAction<{
        dataMethodTransaction: TransactionMethodType[];
      }>,
    ) {
      const { payload } = action;
      state.dataMethodTransaction = payload.dataMethodTransaction;
    },
    setTransactionReportAction(
      state,
      action: PayloadAction<{
        dataTransactionReport: TransactionReportContent;
      }>,
    ) {
      const { payload } = action;
      state.transactionReport = payload.dataTransactionReport;
    },
  },
});

export const {
  setListTransactionsAction,
  setDetailsTransactionAction,
  setTransactionFiltersAction,
  resetTransactionFiltersAction,
  setTransactionStatusAction,
  setTransactionMethodAction,
  setTransactionReportAction
} = slice.actions;
export default slice.reducer;
